function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import StyledGalleryDragHandle from './GalleryDragHandle.styled';
var GalleryDragHandle = forwardRef(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(StyledGalleryDragHandle, _extends({
    size: "small",
    sx: {
      color: '#fff'
    }
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(DragIndicatorIcon, {
    fontSize: "small",
    color: "inherit"
  }));
});
export default GalleryDragHandle;